import moment from 'moment'

class ValidadorDatas {

    validarAoPublicar(licitacao) {
        const validacao = {valido: true, mensagem: ''}
        if (this._validarDataFimEnvioPropostasComDataAtual(licitacao)) {
            validacao.mensagem = 'A Data/Hora do Fim do Credenciamento não pode ser anterior à data de publicação.'
            validacao.valido = false
        }
        return validacao
    }

    validar(licitacao, exibirDataHoraAberturaCredenciamento = false) {
        const validacao = {valido: false, mensagem: ''}
        if (this._deveValidarDataAbertura(licitacao, exibirDataHoraAberturaCredenciamento)) {
            if (this._validarDataAberturaAposFimEnvioPropostas(licitacao)) {
                validacao.mensagem = 'A Data/Hora Abertura Credenciamento não pode ser anterior a Data/Hora Fim Credenciamento.'
                return validacao
            }
            if (this._validarDataDeAberturaComDataAtual(licitacao)) {
                validacao.mensagem = 'A Data/Hora de Abertura não pode ser anterior a Data/Hora atual.'
                return validacao
            }
        }
        if (this._validarDataFimEnvioPropostasComDataAtual(licitacao)) {
            validacao.mensagem = 'A Data/Hora Fim Credenciamento não pode ser anterior a Data/Hora atual.'
            return validacao
        }
        if (this._validarDataLimiteEsclarecimentoImpugnacaoComDataAtual(licitacao)) {
            validacao.mensagem = 'A Data/Hora Limite de Esclarecimento/Impugnação não pode ser anterior a Data/Hora atual.'
            return validacao
        }
        if (this._validarDataLimiteEsclarecimentoImpugnacaoComFimEnvioPropostas(licitacao)) {
            validacao.mensagem = 'A Data/Hora Limite de Esclarecimento/Impugnação não pode ser posterior a Data/Hora Fim Credenciamento.'
            return validacao
        }
        validacao.valido = true
        return validacao
    }

    validarAlteracaoDataFim(licitacao, novaDataFimEnvioProposta) {
        const validacao = {valido: false, mensagem: ''}
        if (!this._dataInformada(novaDataFimEnvioProposta)) {
            validacao.mensagem = 'Informe a nova Data/Hora Fim Credenciamento.'
            return validacao
        }
        const novaDataFim = moment(novaDataFimEnvioProposta)
        if (!novaDataFim.isAfter(moment(new Date()))) {
            validacao.mensagem = 'A nova data de término deve ser posterior à data e hora atuais.'
            return validacao
        }
        const dataInicio = licitacao.dataAbertura || licitacao.dataIniEnvioProposta
        if (this._dataInformada(dataInicio) && !novaDataFim.isAfter(moment(dataInicio))) {
            validacao.mensagem = 'A nova data de término deve ser posterior à data e hora de início do credenciamento.'
            return validacao
        }
        validacao.valido = true
        return validacao
    }

    _deveValidarDataAbertura(licitacao, exibirDataHoraAberturaCredenciamento) {
        return !!exibirDataHoraAberturaCredenciamento && this._dataInformada(licitacao.dataAbertura)
    }

    _dataInformada(data) {
        return !!data && moment(data).isValid()
    }

    _validarDataAberturaAposFimEnvioPropostas(licitacao) {
        if (!this._dataInformada(licitacao.dataFimEnvioProposta)) return true
        const dataAbertura = moment(licitacao.dataAbertura)
        const dataFimEnvio = moment(licitacao.dataFimEnvioProposta)
        return dataAbertura.isAfter(dataFimEnvio)
    }

    _validarDataFimEnvioPropostasComDataAtual(licitacao) {
        if (!this._dataInformada(licitacao.dataFimEnvioProposta)) return false
        const dataAtual = moment(new Date())
        const dataFimEnvioProposta = moment(licitacao.dataFimEnvioProposta)
        return dataFimEnvioProposta.isBefore(dataAtual)
    }

    _validarDataDeAberturaComDataAtual(licitacao) {
        const dataAtual = moment(new Date())
        const dataAbertura = moment(licitacao.dataAbertura)
        return dataAbertura.isBefore(dataAtual)
    }

    _validarDataLimiteEsclarecimentoImpugnacaoComDataAtual(licitacao) {
        if (!this._dataInformada(licitacao.dataLimiteEsclarecimentoImpugnacao)) return false
        const dataLimiteEsclarecimentoImpugnacao = moment(licitacao.dataLimiteEsclarecimentoImpugnacao)
        const dataAtual = moment(new Date())
        return dataLimiteEsclarecimentoImpugnacao.isBefore(dataAtual)
    }

    _validarDataLimiteEsclarecimentoImpugnacaoComFimEnvioPropostas(licitacao) {
        if (!this._dataInformada(licitacao.dataLimiteEsclarecimentoImpugnacao)) return false
        if (!this._dataInformada(licitacao.dataFimEnvioProposta)) return false
        const dataLimiteEsclarecimentoImpugnacao = moment(licitacao.dataLimiteEsclarecimentoImpugnacao)
        const dataFimEnvioProposta = moment(licitacao.dataFimEnvioProposta)
        return dataFimEnvioProposta.isBefore(dataLimiteEsclarecimentoImpugnacao)
    }

}

export default new ValidadorDatas()
